import 'core-js';
import regeneratorRuntime from 'regenerator-runtime'; //for async functions
require('intersection-observer'); //For LazyLoadImage
import 'whatwg-fetch';
import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './service/ApolloServiceHook';
import HeaderLoader from './component/HeaderLoader';
import SuggestLoader from './component/SuggestLoader';
import Demo from './component/Demo';
import Footer from './component/Footer';
import SellerGroupModelListLoader from './component/SellerGroupModelListLoader';
import ItemShippingFeeListComponent from './component/ItemShippingFeeList';
import ClipLoader from './component/clip/ClipLoader';
import ClipUtil from './util/ClipUtil';
import LazyLoadImage from './util/LazyLoadImage';
import CatalogVideo from './component/catalog/CatalogVideo';
import CatalogPreviewModal from './component/catalog/CatalogPreviewModal';
import CatalogPartnerCardLoader from './component/catalog/CatalogPartnerCardLoader';
import CatalogPartnerModalLoader from './component/catalog/CatalogPartnerModalLoader';
import ContentLoader from './component/ContentLoader';
import AppService from './service/AppService';
import AppConfig from './domain/AppConfig';
import WebIntlProvider from './ui/i18n/WebIntlProvider';

import PathUtil from './util/PathUtil';

const appConfig: AppConfig = AppService.appConfig();
const serverHost = AppService.serverHost();

import {AperzaLinkUtil} from '@aperza/util';

AperzaLinkUtil.searchWebHost = appConfig.searchWebHost;

const areIntlLocalesSupported = require('intl-locales-supported');
import i18n from './i18n/i18n';

const localesMyAppSupports = [
  'en', 'ja'
];

import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import AppConfigService from './service/AppConfigService';
import ShippingPriceLoader from './component/ShippingPriceLoader';
import SellerShippingPriceLoader from './component/SellerShippingPriceLoader';
import CatalogCluezDownloadModalLoader from './component/catalog/CatalogCluezDownloadModalLoader';
import CatalogDownloadModalLoader from './component/catalog/CatalogDownloadModalLoader';
import CatalogVideoModal from './component/catalog/CatalogVideoModal';
import CustomPageLoader from './component/customPage/CustomPageLoader';

const pushIntoDataLayer = (data, w = window, l = 'dataLayer') => {
  w[l] = w[l] || [];
  w[l].push({
    'aw.start': new Date().getTime(),
    event: 'aw.js',
    ...data,
  });
};

function initLogRocket() {

  setupLogRocketReact(LogRocket);

  let logRocketKey = 'xdhunq/aperza-web-test';
  if (appConfig.env == AppConfig.ENV_STG) {
    logRocketKey = 'xdhunq/aperza-web-stg';
  } else if (appConfig.env == AppConfig.ENV_PROD) {
    logRocketKey = 'xdhunq/aperza-web-prod';
  }
  LogRocket.init(logRocketKey);
}

const waitForHeaderElement = () => {
  let aperzaHeader = document.getElementById('aperza-header');
  if (aperzaHeader) {
    startApp();
  } else {
    setTimeout(waitForHeaderElement, 10);
  }
};

const waitForDocumentReady = () => {
  if (document.readyState !== 'loading') {
    startApp();
  } else {
    setTimeout(waitForDocumentReady, 10);
  }
};

function startApp() {
  pushIntoDataLayer({
    'aw.type': 'start',
  });
  if (!window.jQuery) {
    console.warn('WARNING! APERZA web-component requires jQuery for some of the modules!');
  }

  if (global.Intl) {
    // Determine if the built-in `Intl` has the locale data we need.
    if (!areIntlLocalesSupported(localesMyAppSupports)) {
      console.log('NO areIntlLocalesSupported');
      // `Intl` exists, but it doesn't have the data we need, so load the
      // polyfill and patch the constructors we need with the polyfill's.
      let IntlPolyfill = require('intl');
      Intl.NumberFormat = IntlPolyfill.NumberFormat;
      Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    }
  } else {
    // No `Intl`, so use and load the polyfill.
    global.Intl = require('intl');
  }

  const headerElement = document.getElementById('aperza-header');
  const suggestElement = document.getElementById('suggest-center');
  const demoElement = document.getElementById('aperza-web-demo');
  const footerElement = document.getElementById('aperza-footer');

  // New Clipper from `WEB-COMPONENT`
  const clipElement = document.getElementById('web-clip-component');
  let clipElements = document.getElementsByClassName('web-clip-component');

  let catalogVideoElements = document.getElementsByClassName('catalog-video-component');

  let partnerLinkCard = document.getElementById('partner-link-card');

  const sellerProductGroupListComponent = document.getElementById('aperza-seller-group-models-component');
  // const catalogYoutubeVideoComponent = document.getElementById('catalog-video-component');

  const itemShippingFeeListComponent = document.getElementById('aperza-item-shipping-fees-component');

  let contentElements = document.getElementsByClassName('aperza-content');

  // try to search by class - in case there are multiple components in single page (ie. cart for smartphone and pc)
  const shippingPriceComponents = document.getElementsByClassName('aperza-shipping-price-component-class');
  const shippingPriceComponent = document.getElementById('aperza-shipping-price-component');

  const customPageComponent = document.getElementById('aperza-custompage-component');

  if (headerElement) {
    $(headerElement).css({opacity: 0, visibility: "visible"});
    ReactDOM.hydrate(<HeaderLoader  {...AppConfigService.resolveHeaderConfigurations()} />, headerElement, () => {
      waitForElement("#aperza-header", function () {
        $(headerElement).animate({opacity: 1}, 250);
        $('#aperza-header-init').fadeOut();
      });
    });

    // setTimeout(function() {
    //   $('#aperza-header-init').hide();
    //   $('#aperza-header-wrapper').css('min-height','');
    // }, 1000);
  }

  function waitForElement(elementPath, callBack) {
    window.setTimeout(function () {
      if ($(elementPath).length) {
        callBack(elementPath, $(elementPath));
      } else {
        waitForElement(elementPath, callBack);
      }
    }, 500)
  }

  if (suggestElement) {
    let rfType = suggestElement.getAttribute('data-rf-type');
    ReactDOM.render(<SuggestLoader
      rfType={rfType} {...AppConfigService.resolveHeaderConfigurations()} />, suggestElement);
  }

  if (demoElement) {
    ReactDOM.render(<Demo/>, demoElement);
  }

  if (footerElement) {
    ReactDOM.render(<Footer/>, footerElement);
  }

  if (sellerProductGroupListComponent) {
    let sellerContactId = sellerProductGroupListComponent.dataset.sellerContactId;
    let sellerModelId = sellerProductGroupListComponent.dataset.sellerModelId;
    ReactDOM.render(<SellerGroupModelListLoader sellerContactId={sellerContactId}
                                                sellerModelId={sellerModelId}/>, sellerProductGroupListComponent);
  }

  if (clipElement) {
    ReactDOM.render(<ClipLoader {...ClipUtil.getParametersFromClipElement(clipElement)} />, clipElement);
  }

  if (clipElements) {
    let elementsArray = Array.from(clipElements);
    elementsArray.forEach((element) => {
      ReactDOM.render(<ClipLoader {...ClipUtil.getParametersFromClipElement(element)} />, element);
    })
  }

  if (catalogVideoElements) {
    let elementsArray = Array.from(catalogVideoElements);
    elementsArray.forEach((element) => {
      ReactDOM.render(
        <Suspense fallback={<div></div>}>
          <CatalogVideo videoId={element.getAttribute("data-video-id")}/>
        </Suspense>, element);
    })
  }

  if (contentElements) {
    let elementsArray = Array.from(contentElements);
    elementsArray.forEach((element) => {
      ReactDOM.render(<ContentLoader tag={element.getAttribute("data-tag")}/>, element);
    })
  }

  if (shippingPriceComponents && shippingPriceComponents.length !== 0) {
    // console.log('rendering  shipping price by className');
    // loop through all price components
    for (var i = 0; i < shippingPriceComponents.length; i++) {
      let currentShippingPriceComponent = shippingPriceComponents.item(i);
      let modelIds = currentShippingPriceComponent.dataset.modelIdCsv;
      let prefectureCode = currentShippingPriceComponent.dataset.prefectureCode;
      let quantities = currentShippingPriceComponent.dataset.quantityCsv;

      ReactDOM.render(<ShippingPriceLoader modelIds={modelIds} prefectureCode={prefectureCode}
                                           quantities={quantities}/>, currentShippingPriceComponent);
    }
  } else if (shippingPriceComponent) {
    // just look for single id
    // console.log('rendering  shipping price by id');
    let modelIds = shippingPriceComponent.dataset.modelIdCsv;
    let prefectureCode = shippingPriceComponent.dataset.prefectureCode;
    let quantities = shippingPriceComponent.dataset.quantityCsv;

    ReactDOM.render(<ShippingPriceLoader modelIds={modelIds} prefectureCode={prefectureCode}
                                         quantities={quantities}/>, shippingPriceComponent);
  }

  if (itemShippingFeeListComponent) {
    let sellerContactId = itemShippingFeeListComponent.dataset.sellerContactId;
    let overseas = itemShippingFeeListComponent.dataset.overseas;
    let lang = itemShippingFeeListComponent.dataset.lang;
    ReactDOM.render(<SellerShippingPriceLoader sellerContactId={sellerContactId} overseas={overseas}
                                               lang={lang}/>, itemShippingFeeListComponent);
    // ReactDOM.render(<ItemShippingFeeListComponent sellerContactId={sellerContactId} overseas={overseas} lang={lang}/>, itemShippingFeeListComponent);
  }

  if (AppConfigService.isAperzaCompanyPage() || customPageComponent) {
    window.aperza.aw.isAperzaCompanyPage = new Date().getTime();
    let aperzaCatalogPreviewModal = document.createElement('div');
    aperzaCatalogPreviewModal.id = 'aperza-catalog-preview-modal';
    document.body.appendChild(aperzaCatalogPreviewModal);
    ReactDOM.render(
      <Suspense fallback={<div></div>}>
        <CatalogPreviewModal/>
      </Suspense>
      , aperzaCatalogPreviewModal);

    let aperzaCluezCatalogDownloadModal = document.createElement('div');
    aperzaCluezCatalogDownloadModal.id = 'aperza-catalog-cluez-download-modal';
    document.body.appendChild(aperzaCluezCatalogDownloadModal);
    ReactDOM.render(<CatalogCluezDownloadModalLoader show={false}/>, aperzaCluezCatalogDownloadModal);

    // let aperzaCatalogDownloadModal = document.createElement('div');
    // aperzaCatalogDownloadModal.id = 'aperza-catalog-download-modal';
    // document.body.appendChild(aperzaCatalogDownloadModal);
    // ReactDOM.render(
    //   <ApolloProvider client={apolloClient}>
    //
    //       <CatalogDownloadModalLoader/>
    //
    //   </ApolloProvider>
    //   , aperzaCatalogDownloadModal);

    let aperzaCatalogVideoModal = document.createElement('div');
    aperzaCatalogVideoModal.id = 'aperza-catalog-video-modal';
    document.body.appendChild(aperzaCatalogVideoModal);
    ReactDOM.render(<CatalogVideoModal show={false}/>, aperzaCatalogVideoModal);
  }

  if (PathUtil.isCatalogPage(PathUtil.currentPath(), appConfig.langCode)) {
    /// TODO : check API + Logged IN User for the Partner Card
    let loadCatalogPartner = true;
    if (loadCatalogPartner && partnerLinkCard.dataset.document_id) {
      // Load Card
      ReactDOM.render(
        <Suspense fallback={<div></div>}>
          <CatalogPartnerCardLoader documentId={partnerLinkCard.dataset.document_id}/>
        </Suspense>
        , partnerLinkCard)
      // Load Modal Loader
      let aperzaCatalogPartnerPreviewModal = document.createElement('div');
      aperzaCatalogPartnerPreviewModal.id = 'aperza-catalog-partner-preview-modal';
      document.body.appendChild(aperzaCatalogPartnerPreviewModal);
      ReactDOM.render(
        <Suspense fallback={<div></div>}>
          <CatalogPartnerModalLoader/>
        </Suspense>
        , aperzaCatalogPartnerPreviewModal)
    }
  }

  if (customPageComponent) {
    let companyContractId = customPageComponent.dataset.companyContractId;
    let pageId = customPageComponent.dataset.pageId;
    let pageDisplayId = customPageComponent.dataset.pageDisplayId;
    let companyContractDisplayId = customPageComponent.dataset.companyContractDisplayId;
    let useDraft = customPageComponent.dataset.useDraft === "true" || false; // default to false when not defined

    ReactDOM.render(
      <ApolloProvider client={apolloClient}>
        <CustomPageLoader companyContractId={companyContractId}
                                        pageId={pageId}
                                        pageDisplayId={pageDisplayId}
                                        companyContractDisplayId={companyContractDisplayId}
                                        useDraft={useDraft}/>
      </ApolloProvider>
                                      , customPageComponent);
  }

  LazyLoadImage.init();

  window.aperza.aw.init = new Date().getTime();
}

function bootstrap() {
  if (!window.aperza) {
    window.aperza = {};
  }
  if (!window.aperza.aw) {
    window.aperza.aw = {};
  }

  pushIntoDataLayer({
    'aw.type': 'bootstrap',
  });
  let query = `
{
  viewer {
    id
    userId
    isInternalIp
    isLogRocket
    endUserType
    buyer {
      approvalFlag
    }
  }
}
  `;

  return fetch(`${serverHost}/graphql`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({query: query}),
  }).then(response => {
    return response.json();
  }).then(data => {
    //console.log('bootstrap info', data);
    let viewer = data.data.viewer;
    if (
      AppConfigService.shouldInitLogRocket(viewer)
    ) {
      initLogRocket();
    }
    //waitForHeaderElement();
    waitForDocumentReady();
    return data;
  });
}

bootstrap();


